import { AxiosError } from "axios";
import client from "../../api/client";
import { TMemberRegisterStatusResponce } from "../../api/member/register/status";
import TApiResult from "../../types/api/TApiResult";
import getErrorProperty from "./config/getErrorProperty";

export type TApMemberRegisterStatusResult = {
  result?: TMemberRegisterStatusResponce;
};
export const postMemberRegisterStatus = async (
  email: string,
  password: string
): Promise<TApiResult & TApMemberRegisterStatusResult> => {
  return client()
    .member.register.status.post({ body: { email: email, password: password } })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(
        e,
        "postMemberRegisterStatus"
      );
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
